import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openContentFullscreen } from '../../actions/contentFullscreen';
import { UserCardImage } from '../../components/UserCard/UserCardImage';
import { currentOpenChatIDSelector } from '../../selectors';
import { TChatImageFile } from '../../types/imageFile';
import { getFileSrc } from '../../utils/getFileSrc';

interface IUserCardImageProps {
  image: TChatImageFile;
}

export const UserCardImageContainer: React.FC<IUserCardImageProps> = ({ image }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  const chatId = useSelector(currentOpenChatIDSelector);

  const imageEl = React.useRef<HTMLImageElement>(null);

  const { uid } = image;

  const src = getFileSrc(uid, chatId);

  const dispatch = useDispatch();

  const handleError = () => {
    setIsLoading(false);
    setIsError(true);
  };

  const handleLoad = () => {
    setIsLoading(false);

    if (imageEl.current && imageEl.current.naturalWidth === 0) {
      setIsError(true);
    }
  };

  const handleClick = () => {
    dispatch(
      openContentFullscreen({
        selectedImageUid: uid,
      }),
    );
  };

  return (
    <UserCardImage
      ref={imageEl}
      src={src}
      image={image}
      onLoad={handleLoad}
      onError={handleError}
      onClick={handleClick}
      isLoading={isLoading}
      isError={isError}
    />
  );
};
